import React from 'react';
import {KTMScreen,ActionEvent,RenderEvent,renderScreen} from 'ktm-ui';
import {KTMApi} from 'api/KTMApi';
import {Layout,Dialog,Button,Display,Line,Card,Column,Panel} from 'ktm-ui';

interface IdsBenefit {
    Id:string;
    Policy_Id:string;
    LSAAdminRate:number;
    LSAMinAdminFee:number;
    LSAMaxAdminFee:number;
    CarryFwdLSA:string;
};

export default KTMScreen({name:"planadmin.product.edit-lsa"}, class extends React.Component<{policyBenefit_id:string}> {

    data:{
        dsBenefit:IdsBenefit;
    }

    render(){
        return renderScreen(this);
    }

    async start({screen}:ActionEvent){
        screen.defaultRecord = "@dsBenefit";
        await KTMApi.start(screen,{
            "@policyBenefit_id":this.props.policyBenefit_id,
        });
        screen.title = "Edit LSA Details";
    }

    main({field,draw,action}:RenderEvent){
        return (
            <Layout>
                {draw(this.header)}
                {draw(this.main_tab)}
                {draw(this.footer)}
            </Layout>
        );
    }

    header({field,draw,action}:RenderEvent){
        return (
            <Dialog.Header label="Edit LSA Details"/>
        );
    }

    footer({field,draw,action}:RenderEvent){
        return (
            <Dialog.Footer>
                <Button action={action(this.submit)} label="Save" size="large" style="primary"/>
            </Dialog.Footer>
        );
    }

    details({field,draw,action}:RenderEvent){
        return (
            <Card>
                <Line>
                    <Display required field={field("LSAAdminRate")}/>
                    <Display required field={field("LSAMinAdminFee")}/>
                    <Display required field={field("LSAMaxAdminFee")}/>
                </Line>
                <Display required field={field("CarryFwdLSA")}/>
            </Card>
        );
    }

    main_tab({field,draw,action}:RenderEvent){
        return (
            <Panel>
                <Column>
                    {draw(this.details)}
                </Column>
            </Panel>
        );
    }

    async submit({screen}:ActionEvent){
        await KTMApi.action(screen,"submit",{
            "@dsBenefit.LSAAdminRate":this.data.dsBenefit.LSAAdminRate,
            "@dsBenefit.LSAMinAdminFee":this.data.dsBenefit.LSAMinAdminFee,
            "@dsBenefit.LSAMaxAdminFee":this.data.dsBenefit.LSAMaxAdminFee,
            "@dsBenefit.CarryFwdLSA":this.data.dsBenefit.CarryFwdLSA,
            "@policyBenefit_id":this.props.policyBenefit_id,
        });
        screen.close({"continue":true});
    }

});
